import { Injectable, NgZone } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { interval } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ServiceWorkerService {
	public hasNewVersion = false;

	constructor(public updates: SwUpdate, public ngZone: NgZone) {
		this.startServiceWorker();
	}

	public startServiceWorker(): void {
		if (this.updates.isEnabled) {
			this.ngZone.runOutsideAngular(() =>
				interval(300000).subscribe(() => {
					this.updates.checkForUpdate();
				})
			);
		}
	}

	public checkForUpdates(): void {
		this.updates.available.subscribe(() => {
			this.updateApplication();
		});
	}

	public updateApplication(): void {
		this.updates.activateUpdate().then(() => {
			this.hasNewVersion = true;
		});
	}
}
